import type { ReviewMessage } from '../outreachTypes';

const OPEN: ReadonlySet<string> = new Set(['draft', 'needsEdit']);

export function isOpenPitch(message: ReviewMessage): boolean {
  return OPEN.has(message.status);
}

/**
 * The rows of the list (design outreach-v2 h1): the pitches that wait, and the ones that the artist
 * approved or skipped on this visit (they stay, dimmed). Older approved or skipped rows of the
 * campaign do not show.
 */
export function visibleReviewRows(messages: ReviewMessage[], decided: ReadonlySet<string>): ReviewMessage[] {
  return messages.filter((message) => isOpenPitch(message) || decided.has(message.messageUuid));
}

/** The open pitch to show: the picked one while it waits, else the first that waits after it, else the first. */
export function currentReviewRow(rows: ReviewMessage[], picked: string | null): ReviewMessage | null {
  const open = rows.filter(isOpenPitch);
  if (open.length === 0) {
    return null;
  }
  const at = picked === null ? -1 : rows.findIndex((row) => row.messageUuid === picked);
  const pickedRow = at >= 0 ? rows[at] : undefined;
  if (pickedRow !== undefined && isOpenPitch(pickedRow)) {
    return pickedRow;
  }
  return rows.slice(Math.max(at, 0)).find(isOpenPitch) ?? open[0] ?? null;
}

/** The next open pitch after `uuid`, else the first open one that is not `uuid`. */
export function nextOpenAfter(rows: ReviewMessage[], uuid: string): string | null {
  const at = rows.findIndex((row) => row.messageUuid === uuid);
  const after =
    rows.slice(at + 1).find(isOpenPitch) ?? rows.find((row) => isOpenPitch(row) && row.messageUuid !== uuid);
  return after?.messageUuid ?? null;
}
